// extracted by mini-css-extract-plugin
export default {"wrapper":"Spoiler_wrapper","title":"Spoiler_title","active":"Spoiler_active","content":"Spoiler_content"};